<template>
  <div
    v-if="property"
    class="px-10 pt-3 d-flex flex-row fill-width justify-space-around align-center"
  >
    <GoBack class="shrink pr-3" />
    <div v-if="property" class="grow">
      <h2>
        {{
          "Propiedad Nº" +
            property.id +
            " - " +
            property.address.street +
            " " +
            property.address.number +
            (property.address.unit ? " " + property.address.unit : "") +
            ", " +
            property.address.city +
            ", " +
            property.address.state
        }}
      </h2>
      <p class="body-1 grey--text pt-0">
        {{
          $t("property.type." + property.propertyType.toLowerCase()) +
            " | " +
            $t(
              "contract.show.headers." +
                ((property.features.operation_type || {}).sell
                  ? "sell"
                  : "rent") +
                ".owners",
              { name: property.owner.map(o => o.profile.name).join(", ") }
            )
        }}
      </p>
    </div>
    <div class="text-right">
      <v-btn
        @click.stop="
          $router.push({ name: 'EditProperty', params: { id: property.id } })
        "
        outlined
      >
        {{ $t("action.edit") }}
      </v-btn>

      <v-btn @click.stop="disable" class="ml-2" outlined>
        {{ property.disabled ? "Habilitar" : "Deshabilitar" }}
      </v-btn>

      <v-btn
        @click.stop="book"
        class="ml-2"
        outlined
        v-if="['published', 'booked'].includes(property.state)"
      >
        {{ property.state == "booked" ? "Quitar reserva" : "Reservar" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Property } from "@/graphql/queries/property";
import { EditProperty } from "@/graphql/mutations/properties";
import GoBack from "@/components/GoBack.vue";

export default {
  name: "ShowHeader",

  data() {
    return {
      property: null
    };
  },

  components: {
    GoBack
  },

  created() {
    this.fetchProperty();
  },

  methods: {
    fetchProperty() {
      this.$apollo
        .query({
          query: Property,
          variables: {
            id: this.$route.params.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.property = res.data.property;
        });
    },

    disable() {
      this.$apollo
        .mutate({
          mutation: EditProperty,
          variables: {
            input: {
              propertyId: this.property.id,
              attributes: {
                disabled: !this.property.disabled
              }
            }
          }
        })
        .then(res => {
          this.fetchProperty();
        });
    },

    feature() {
      this.$apollo
        .mutate({
          mutation: EditProperty,
          variables: {
            input: {
              propertyId: this.property.id,
              attributes: {
                featured: !this.property.featured
              }
            }
          }
        })
        .then(res => {
          this.fetchProperty();
        });
    },

    book() {
      this.$apollo
        .mutate({
          mutation: EditProperty,
          variables: {
            input: {
              propertyId: this.property.id,
              attributes: {
                state: this.property.state == "booked" ? "published" : "booked"
              }
            }
          }
        })
        .then(res => {
          this.fetchProperty();
        });
    }
  }
};
</script>
